
<div id="blip-channel-table-container">
    <BlipChannelTableCaption/>
    <div id="blip-channel-table" class="responsive-table">
        <ContentTypeTable 
        contentTypes={contentTypes}/>
        <ChannelSupportTable
        channels={channels}
        contentTypes={contentTypes}/>
    </div>
</div>


<script>
import BlipChannelTableJson from './BlipChannelTable.json';
import BlipChannelTableCaption from './BlipChannelTableCaption.html';
import ChannelSupportTable from './channelSupport/ChannelSupportTable.html';
import ContentTypeTable from './contentType/ContentTypeTable.html';
import ChannelSupportSampleModal from '../ui/modals/ChannelSupportSampleModal.html';

export default {
    data() {
        return {
            channels: BlipChannelTableJson.contentCapabilityPerChannel,
            contentTypes: BlipChannelTableJson.contentTypes,
        };
    },
    components: {
        BlipChannelTableCaption,
        ChannelSupportTable,
        ContentTypeTable,
        ChannelSupportSampleModal
    },
    methods: {
        updateModal({ channel, content }) {
            const { channels } = this.get();
            const channelObj = channels[channel];
            const modal = channelObj.support[content].modal;
            this.setModal(modal);
        },
        setModal ({ title, description, img, docsUrl }) {
            const newModal = {
                title,
                description,
                img: { ...img },
                docsUrl
            };

            this.set({
                modal: newModal
            })
        }
    }
}
</script>